const otherAssetTemplate = `<!DOCTYPE html>
<html>

  <body>
  <div id="equityAsset">
  <div class="heading"><h6>Assets &nbsp; Level &nbsp; Details &nbsp;(Values &nbsp; in &nbsp;{{currency}} )</h6></div>

    <table id="equityAsset-table">
        <tr>
          <th>Asset ID</th>
          <th>Asset</th>
          <th>Current Debt Value &nbsp; ( {{currencySymbol}} )</th>
          <th>Last Debt Value &nbsp; ( {{currencySymbol}} )</th>
        </tr>
        {{#each assets}}
        <tr>
          <td>{{this.id}}</td>
          <td>{{this.name}}</td>
          <td>{{this.currentAppraisalValue}}</td>
          <td>{{this.lastAppraisedValue}}</td>
        </tr>
        {{/each}}
        {{#if (eq this.empty 'true')}}
        <tr>
          <td colspan="4">No  Data</td>
        </tr>
        {{/if}}
      </table>
    </div>
  </body>
</html>
`
;

export default otherAssetTemplate;

